import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../components/UI/ListLinkBox';
import { translate } from '../../../utils/util';
import { checkPermission, getVision } from '../../../services/auth';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../utils/constants';
import * as actionsStock from '../../../actions/stockAction';
import JustificationService from '../../../services/JustificationService';
import SecurityService from '../../../services/SecurityService';

const WarehouseManagement = (props) => {

    useEffect(() => {
        props.getJustifications(props.user.vision);
        // eslint-disable-next-line
    }, []);

    const menu = () => {
        let menuItems = [];

        menuItems = [...menuItems, { route: 'warehousemanagement/location', icon: 'mdi mdi-location-enter', text: translate('change-location:menu.changeLocation') }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'warehousemanagement/stock/search',
                state: {
                    quality: false

                }
            }, icon: 'mdi mdi-magnify', text: translate('stock:query'),
            onClick: () => props.clear()
        }];

        if (VISIONS.Jeep) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'warehousemanagement/stock/search',
                    state: {
                        isPreAllocation: true
                    }
                }, icon: 'mdi mdi-clipboard-check-outline', text: translate('stock:allocation-confirmation'),
                onClick: () => props.clear()
            }];
        }

        if (checkPermission(PERMISSIONS.Stock.Access)) {
            menuItems = [...menuItems, { route: 'warehousemanagement/stock/home', icon: 'mdi mdi-arrow-down', text: translate('stock:write-off') }];
        }

        if (checkPermission(PERMISSIONS.UploadDifusion.Access)) {
            menuItems = [...menuItems, { route: 'warehousemanagement/uploadDiffusion/partnumber', icon: 'mdi mdi-progress-upload', text: translate('stock:upload-diffusion') }];
        }

        menuItems = [...menuItems, {
            route: 'warehousemanagement/report',

            icon: 'mdi mdi-clipboard-list-outline', text: translate('change-location:fila-report'), onClick: () => props.loadConfig(getVision(), ENUMS.eModules.WarehouseManagement.value)
        }];

        if (checkPermission(PERMISSIONS.Stock.Quality)) {
            menuItems = [...menuItems, { route: 'warehousemanagement/quality/home', icon: 'mdi mdi-checkbox-multiple-marked-outline', text: translate('stock:quality') }];
        }

        menuItems = [...menuItems, {
            route: {
                pathname: 'warehousemanagement/stock/log',
                state: {
                    quality: false,
                }
            }, icon: 'mdi mdi-file-alert-outline',
            text: translate('logs', 'stock')
        }];

        menuItems = [...menuItems, { route: 'warehousemanagement/deemsqp', icon: 'mdi mdi-clipboard-outline', text: translate('form-deem-sqp', 'deemsqp') }];

        menuItems = [...menuItems, { route: 'warehousemanagement/mastercim', icon: 'mdi mdi-layers-triple-outline', text: 'Gerar Master CIM' }];

        menuItems = [...menuItems, {
            route: 'warehousemanagement/print/identification',
            icon: 'filter_frames',
            text: translate('identification-label', 'physical-confirmation')
        }];

        menuItems = [...menuItems, {
            route: 'warehousemanagement/palletlabel',
            icon: 'label_outline',
            text: 'Etiqueta Porta Pallet'
        }];

        menuItems = [...menuItems, {
            route: 'warehousemanagement/balancepartNumber',
            icon: 'label_outline',
            text: 'Saldo Desenho Armazenado'
        }];


        menuItems = [...menuItems, {
            route: 'warehousemanagement/shed',
            icon: 'mdi mdi-magnify',
            text: translate('shed-search', 'stock')
        }];


        return menuItems;
    };

    return (
        <div>
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('menu:warehouse-management')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox
                    options={menu()}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => {
            dispatch(actionsStock.clearMaterials());
            dispatch(actionsStock.clearFilter());
        },
        getJustifications: (vision) => {
            dispatch(JustificationService.getJustifications(vision, {}, {}, true));
        },
        loadConfig: (vision, module) => {
            dispatch(SecurityService.loadConfig(vision, module));
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(WarehouseManagement))));

